import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {

  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
   <BrowserRouter basename='/'>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
    <BrowserRouter basename='/'>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
